export default {
  body: `
    When you are ready, click the green <b>Record</b> button and say out loud, “My
    reasons are…”
  `,
  bodySay: `
    Then say your reasons.
  `,
};
